// extracted by mini-css-extract-plugin
export default {"wrapper":"duration-input_wrapper__2Qjwu","selectWrapper":"duration-input_selectWrapper__huDsM","error":"duration-input_error__yjA1w","disabled":"duration-input_disabled__6YdL8"};